import { useEffect } from 'react';
import { useDiscountContext } from '../store/discountContext';
import { useSelectionByVariableKey } from '@k3/core';
import { useShopName } from './useShopName';
import { useDealer } from './useDealer';
import { useIsKioskMode } from './useIsKioskMode';

export const usePos = () => {
  const dealer = useDealer();
  const store = useSelectionByVariableKey('pos');

  const input = store?.data?.inputText;
  if (input) {
    return input;
  }

  switch (dealer) {
    case 'kraft':
      return 'MKO';
    case 'mahler':
      return 'SBL';
    case 'scontode':
      return 'SEC';
    case 'DMK':
      return 'DMK';
    case 'schrankwerkde':
      return 'OWD';
    case 'hoeffner':
    default:
      return 'HOS';
  }
};

export const useLoadDiscountData = () => {
  const { setDiscount } = useDiscountContext();
  const pos = usePos();
  const model = useShopName();
  const isKioskMode = useIsKioskMode();

  useEffect(() => {
    (async () => {
      if (model) {
        // prettier-ignore
        const url = `${process.env.REACT_APP_API_HUB}/discount?store=${pos}&model=${model}${ isKioskMode ? '&viewmode=kiosk' : '' }`;

        const res = await fetch(url);
        setDiscount(await res.json());
      }
    })();
  }, [pos, model]);
};
